export var SDK_VERSION = '6.3.5';
//# sourceMappingURL=version.js.map